import { currentLocation } from "routes/currentLocation";
import { ROUTE_CHANGED } from "state/routeChange";
/* Adds the current location pathname and query params for all the redux actions */
export const pathname = _store => next => action => {
  // For route-change actions tag with the location being left (payload.from).
  // currentLocation() has already advanced to the destination by the time
  // ROUTE_CHANGED is dispatched, so reading it here would tag the action with
  // the new route and break leave-page cleanup in reducers that compare
  // action.pathname (the origin) against action.payload.location (the
  // destination) — e.g. reset-password, cart, editor error modal.
  const location =
    action.type === ROUTE_CHANGED ? action.payload.from : currentLocation();
  if (location) {
    action.pathname = location.pathname;
    action.queryParams = location.search;
  }

  return next(action);
};

export default pathname;
